import moment from 'moment';
import type { ConfigurationSettings } from 'src/services/configurationService';

/**
 * Adds a fetched page of settings versions to those already loaded: versions already present
 * are replaced by id, new ones appended, and the list is kept newest first.
 */
export const mergeConfigurationSettings = (
  loaded: ConfigurationSettings[] | null,
  page: ConfigurationSettings[],
): ConfigurationSettings[] => {
  const previous = loaded || [];
  const merged = [...previous];

  page.forEach((item) => {
    const index = previous.findIndex((prevItem) => prevItem.id === item.id);

    if (index > -1) {
      merged[index] = item;
    } else {
      merged.push(item);
    }
  });

  merged.sort((a, b) => +moment(b.created_at) - +moment(a.created_at));

  return merged;
};
